import {AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {Question} from '../../models/underwriter.model';
import {newGuid, parseOptions} from '../question-helper';

@Component({
    selector: 'app-question-yes-no',
    templateUrl: './question-yes-no.component.html',
    styleUrls: ['./question-yes-no.component.scss'],
    standalone: false
})
export class QuestionYesNoComponent implements OnInit, OnChanges, AfterViewInit {

  @Input() question: Question;
  @Input() readOnly = false;
  @Output() questionAnswer = new EventEmitter();

  uniqueControlName = `radio-name-${newGuid()}`;
  items: any[] = [];
  itk = '';
  constructor() { }

  ngAfterViewInit(): void {

    let yesNoControls = document.querySelectorAll('.custom-yesno');

    function allYesNoControlsAreActive() {
      let allYesNoControlsAreActive = true;
      yesNoControls.forEach(function (yesNoControl) {
        if (!yesNoControl.classList.contains('is-active')) {
          allYesNoControlsAreActive = false;
        }
      });
      return allYesNoControlsAreActive;
    }

    // loop through each yesNoControl and add 'is-active' class to the selected option
    yesNoControls.forEach(function (yesNoControl) {
      let yesNoOptions = yesNoControl.querySelectorAll('input');
      yesNoOptions.forEach(function (yesNoOption) {
        yesNoOption.addEventListener('change', function () {
          yesNoControl.classList.add('is-active');

          // check if all yesNoControls have 'is-active' class
          if (allYesNoControlsAreActive()) {
            //document.querySelector('#next-question').removeAttribute('disabled');
          }

        });
      });
    });

  }

  ngOnInit(): void {

  }
  
  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.question?.currentValue !== changes?.question?.previousValue) {
      this.question = changes?.question?.currentValue;
      if (this.question?.options) {
        this.items = parseOptions(this.question?.options
        );
        if (this.items?.length) {
          this.items.sort((a, b) => a.answer_order > b.answer_order ? 1 : a.answer_order < b.answer_order ? -1 : 0);
        }
      }
      this.updateItkFromSelection();
    }
    if (changes?.readOnly?.currentValue !== changes?.readOnly?.previousValue) {
      this.readOnly = changes?.readOnly?.currentValue;
    }
   
  }

  checkRadio(option: any): void {
    try {
      const itk = JSON.parse(this.question.itk);
      this.itk = itk.find(i => i.answer_id === option?.cent_aq_answer_id)?.itk_comment;
      if (!this.itk) this.itk = itk.find(i => i.answer_id === 0)?.itk_comment;
    } catch { }
    this.question.answer = option.answer;
    this.question.answer_id = option.cent_aq_answer_id;
    this.updateItkFromSelection(option);
    this.questionAnswer.emit(this.question);
  }

  private updateItkFromSelection(selectedOption?: any): void {
    this.itk = '';
    if (!this.question?.itk) {
      return;
    }

    let itkItems: any[] = [];
    try {
      itkItems = JSON.parse(this.question.itk);
    } catch (error) {
      return;
    }

    const resolvedOption = selectedOption || this.items.find(item => item.answer === this.question?.answer);
    const answerId = resolvedOption?.cent_aq_answer_id ?? this.question?.answer_id;

    this.itk = itkItems.find(i => i.answer_id === answerId)?.itk_comment;
    if (!this.itk) {
      this.itk = itkItems.find(i => i.answer_id === 0)?.itk_comment || '';
    }
  }

}
